<template>
  <li>
    <div
      :class="isFocused ? 'active' : ''"
      v-html="suggestionHtml"
      @click.prevent="currentSuggestion(true)"
    ></div>
  </li>
</template>
<script>
export default {
  name: "AutoCompleteItem",
  props: {
    autoCompleteItem: Object,
    index: Number,
    query: String,
    currentSelectionIndex: Number,
  },
  data: function () {
    return {
      suggestionHtml: "",
      isFocused: false,
    };
  },
  emits: ["currentSuggestion", "currentSuggestionItem"],
  created() {
    this.boldQuery();
  },
  methods: {
    boldQuery() {
      if (this.query.length !== 0) {
        var keywords = this.query.split(" ").join("|");
        this.suggestionHtml = this.autoCompleteItem.value.replace(
          new RegExp("(" + keywords + ")", "gi"),
          "<b>$1</b>"
        );
      } else {
        this.suggestionHtml = this.autoCompleteItem.value;
      }
    },
    currentSuggestion(click) {
      if (!click) {
        this.isFocused = true;
      }
      this.$emit("currentSuggestion", this.autoCompleteItem.value, click);
      this.$emit("currentSuggestionItem", this.autoCompleteItem, click);
    },
  },
  watch: {
    autoCompleteItem: {
      deep: true,
      handler() {
        this.boldQuery();
      },
    },
    currentSelectionIndex(i) {
      if (i == this.index) {
        this.currentSuggestion(false);
      } else {
        this.isFocused = false;
      }
    },
  },
};
</script>
